
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/active/[pageId]/[name]",
      function () {
        return require("private-next-pages/active/[pageId]/[name].tsx");
      }
    ]);
  